import { getAppSettings } from '@/shared/getAppSettings';

export const partnerAppUrl = (pathname: string) => {
  return `${getAppSettings().enSiteDomain}/os${pathname}`;
};
